export default {
    MUTUAL_AID_OPEN_EDIT_BENCHMARK_CONTRIBUTION_DIALOG: 'MUTUAL_AID_OPEN_EDIT_BENCHMARK_CONTRIBUTION_DIALOG',
    MUTUAL_AID_CLOSE_EDIT_BENCHMARK_CONTRIBUTION_DIALOG: 'MUTUAL_AID_CLOSE_EDIT_BENCHMARK_CONTRIBUTION_DIALOG',
    MUTUAL_AID_SET_CONTRIBUTION_BENCHMARK: 'MUTUAL_AID_SET_CONTRIBUTION_BENCHMARK',
    MUTUAL_AID_OPEN_THANKYOU_DIALOG: 'MUTUAL_AID_OPEN_THANKYOU_DIALOG',
    MUTUAL_AID_CLOSE_THANKYOU_DIALOG: 'MUTUAL_AID_CLOSE_THANKYOU_DIALOG',
}